import {
  BaseError,
  ErrorType,
  IMEvent,
  IMonitor,
  LoggerLevel,
  TrackerTypeMap,
  im_proto,
} from '@byted/im-web-sdk';

export class SlardarWebMonitor implements IMonitor {
  private slardar: any;

  public constructor(inst: any) {
    this.slardar = inst;
  }

  public errorTypeBlacklist = [ErrorType.NetworkError];

  public emitError(error: BaseError, tagKv: { [k: string]: string }): void {
    if (typeof this.slardar?.captureException !== 'function') {
      return;
    }

    if (!this.errorTypeBlacklist.includes(error.type)) {
      try {
        this.slardar?.captureException(error, {
          ...tagKv,
          type: `${error.type}:${ErrorType[error.type]}`,
          msg: error.msg,
          logid: error.logid,
          args: error.args,
        });
      } catch (error) {}
    }
  }

  public emitNetwork(
    req: im_proto.Request | null,
    resp: im_proto.Response,
    tagKv: { [k: string]: string },
  ): void {
    if (resp !== undefined) {
      if (resp.status_code !== 0) {
        try {
          this.slardar?.('sendLog', {
            level: 'error',
            content: `Response Error:${resp.status_code}, cmd: ${resp.cmd} msg: ${resp.error_desc}, logid: ${resp.log_id}`,
            extra: {
              cmd: `${resp.cmd}`,
              ...tagKv,
            },
          });
        } catch (error) {}
      }
    }
  }

  public emitEvent(event: IMEvent, sender: any, args: any): void {
    return;
  }

  public emitLog(level: LoggerLevel, args: any[]): void {
    if (level === LoggerLevel.debug) {
      // 不上报 debug 日志
      return;
    }

    const tags: { [k: string]: string } = {};
    args.forEach((val: any, idx: number) => {
      tags[idx] = val;
    });
    try {
      this.slardar?.('sendLog', {
        level: LoggerLevel[level],
        content: args.join(','),
        extra: { ...tags },
      });
    } catch (error) {}
  }

  public emitTracker<T extends keyof TrackerTypeMap>(
    name: T,
    tagKv: TrackerTypeMap[T],
  ): void {
    try {
      this.slardar?.('sendLog', {
        level: 'debug',
        content: name,
        extra: tagKv,
      });
    } catch (error) {}
  }

  /**
   * 建议使用 Tea 上报 {@link TeaMonitor}
   */
  public emitMetrics(
    name: string,
    metrics: { [k: string]: number } = {},
    tagKv: { [k: string]: string } = {},
  ): void {
    return;
  }
}

// 自定义 slardar，改写原来 emitMetrics 空行为，仍然执行上报
export class CustomSlardarWebMonitor extends SlardarWebMonitor {
  public customSlardar: any;
  public constructor(inst: any) {
    super(inst);
    this.customSlardar = inst;
  }
  public emitMetrics(
    name: string,
    metrics: { [k: string]: number } = {},
    tagKv: { [k: string]: string } = {},
  ): void {
    if (['imsdk.network.request', 'imsdk.frontier.receive'].includes(name))
      return;
    try {
      this.customSlardar?.('sendEvent', {
        name,
        metrics,
        categories: tagKv,
      });
    } catch (error) {}
  }
}
